module.exports = __webpack_public_path__ + "static/SFMono-MediumItalic-9fbdbe4e2d56f80d6775b61f9b264df8.woff";